/**
 * Preset sizes for the Coin
 */
export var CoinSize;
(function (CoinSize) {
    CoinSize[CoinSize["size16"] = 16] = "size16";
    CoinSize[CoinSize["size20"] = 20] = "size20";
    CoinSize[CoinSize["size24"] = 24] = "size24";
    CoinSize[CoinSize["size32"] = 32] = "size32";
    CoinSize[CoinSize["size40"] = 40] = "size40";
    CoinSize[CoinSize["size72"] = 72] = "size72";
})(CoinSize || (CoinSize = {}));
